/* em - Product Main: gallery (Swiper main + thumbs), variant image sync, upsell carousel */
(function () {
  'use strict';

  function initGallery(root) {
    if (root.dataset.emInit === '1' || typeof Swiper === 'undefined') return;
    var mainEl = root.querySelector('[data-gallery-main]');
    var thumbsEl = root.querySelector('[data-gallery-thumbs]');
    var progressEl = root.querySelector('[data-gallery-progress]');
    if (!mainEl) return;
    root.dataset.emInit = '1';

    var mq = window.matchMedia('(min-width: 990px)');
    var hasThumbs = thumbsEl && thumbsEl.querySelectorAll('.swiper-slide').length > 1;

    function build() {
      var thumbs = null;
      if (hasThumbs) {
        thumbs = new Swiper(thumbsEl, {
          spaceBetween: 10,
          watchSlidesProgress: true,
          watchOverflow: true,
          slidesPerView: 'auto',
          direction: mq.matches ? 'vertical' : 'horizontal'
        });
        thumbs.on('progress', updateFades);
        thumbs.on('resize', updateFades);
      }
      var main = new Swiper(mainEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: progressEl ? { el: progressEl, type: 'progressbar' } : false,
        thumbs: thumbs ? { swiper: thumbs } : undefined
      });
      root._emMain = main;
      root._emThumbs = thumbs;
    }

    // Show a white top/bottom fade when the thumbnail strip has more items than fit.
    function updateFades() {
      var t = root._emThumbs;
      if (!thumbsEl) return;
      if (!t || !mq.matches) { thumbsEl.classList.remove('is-top', 'is-bottom'); return; }
      var canScroll = !t.isLocked;
      thumbsEl.classList.toggle('is-bottom', canScroll && !t.isEnd);
      thumbsEl.classList.toggle('is-top', canScroll && !t.isBeginning);
    }

    // Cap the thumbnail column to the exact height of the main image (desktop only).
    function syncThumbHeight() {
      var t = root._emThumbs;
      if (!t || !thumbsEl) return;
      if (mq.matches) {
        var h = mainEl.getBoundingClientRect().height;
        if (h) { thumbsEl.style.height = h + 'px'; t.update(); }
      } else {
        thumbsEl.style.height = '';
        t.update();
      }
      updateFades();
    }

    function rebuild() {
      try { if (root._emMain) root._emMain.destroy(true, true); } catch (e) {}
      try { if (root._emThumbs) root._emThumbs.destroy(true, true); } catch (e) {}
      root._emMain = null;
      root._emThumbs = null;
      build();
      syncThumbHeight();
    }

    build();
    syncThumbHeight();

    window.addEventListener('load', syncThumbHeight);
    if (window.ResizeObserver) {
      new ResizeObserver(syncThumbHeight).observe(mainEl);
    } else {
      window.addEventListener('resize', syncThumbHeight);
    }

    // Swiper can't cleanly switch `direction` via breakpoints (vertical thumbs on desktop,
    // horizontal on mobile) — that causes the flicker. Fully rebuild when crossing the boundary.
    if (mq.addEventListener) mq.addEventListener('change', rebuild);
    else if (mq.addListener) mq.addListener(rebuild);
  }

  // Filename (last path segment, no query) — lets us match a variant image to a gallery
  // slide even when the gallery is built from raw metafield URLs (no media id).
  function fileKey(url) {
    if (!url) return '';
    return url.split('?')[0].split('#')[0].split('/').pop().toLowerCase();
  }

  function slideToVariant(variant) {
    if (!variant) return;
    var mediaId = variant.featured_media && variant.featured_media.id;
    var imgSrc =
      (variant.featured_image && variant.featured_image.src) ||
      (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) ||
      '';
    var wantKey = fileKey(imgSrc);

    document.querySelectorAll('.em-product-gallery').forEach(function (root) {
      var main = root._emMain;
      if (!main) return;
      var isMedia = root.getAttribute('data-source') !== 'metafield';
      var imgs = root.querySelectorAll('[data-gallery-main] .swiper-slide img');
      var target = -1;

      for (var i = 0; i < imgs.length; i++) {
        var im = imgs[i];
        // 1) exact media id (product.media galleries)
        if (isMedia && mediaId && String(im.getAttribute('data-media-id')) === String(mediaId)) {
          target = i;
          break;
        }
        // 2) same source file (works for metafield URLs too)
        var key = fileKey(im.getAttribute('data-original-src') || im.getAttribute('src'));
        if (wantKey && key && key === wantKey) {
          target = i;
          break;
        }
      }

      // 3) fallback: media position (only safe for product.media galleries)
      if (target === -1 && isMedia && variant.featured_media && variant.featured_media.position) {
        var pos = variant.featured_media.position - 1;
        if (pos >= 0 && pos < imgs.length) target = pos;
      }

      if (target >= 0) main.slideTo(target);
    });
  }

  function initUpsell(up) {
    if (up.dataset.emInit === '1') return;
    up.dataset.emInit = '1';
    var list = up.querySelector('.product-upsell__list');
    var prev = up.querySelector('[data-upsell-prev]');
    var next = up.querySelector('[data-upsell-next]');
    if (!list) return;

    function step(dir) {
      var item = list.querySelector('.product-upsell__item');
      var w = item ? item.getBoundingClientRect().width + 12 : list.clientWidth;
      list.scrollBy({ left: dir * w, behavior: 'smooth' });
    }
    function updateArrows() {
      var maxScroll = list.scrollWidth - list.clientWidth - 1;
      if (prev) prev.disabled = list.scrollLeft <= 0;
      if (next) next.disabled = list.scrollLeft >= maxScroll;
    }
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
    list.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  }

  // Payment icons: white edge fades that appear only while the strip can scroll further.
  function initPayments(wrap) {
    if (wrap.dataset.emInit === '1') return;
    var strip = wrap.querySelector('[data-payments]');
    if (!strip) return;
    wrap.dataset.emInit = '1';

    function update() {
      var maxScroll = strip.scrollWidth - strip.clientWidth - 1;
      var canScroll = maxScroll > 0;
      wrap.classList.toggle('is-start', canScroll && strip.scrollLeft > 1);
      wrap.classList.toggle('is-end', canScroll && strip.scrollLeft < maxScroll);
    }

    strip.addEventListener('scroll', update, { passive: true });
    if (window.ResizeObserver) new ResizeObserver(update).observe(strip);
    else window.addEventListener('resize', update);
    window.addEventListener('load', update);
    update();
  }

  function initAll() {
    document.querySelectorAll('.em-product-gallery').forEach(initGallery);
    document.querySelectorAll('.em-upsell').forEach(initUpsell);
    document.querySelectorAll('[data-payments-wrap]').forEach(initPayments);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Sync gallery to the variant's featured image on color/variant change (Dawn pub/sub).
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      slideToVariant(event.data && event.data.variant);
    });
  }

  // Theme editor: re-init when the section reloads.
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target;
    if (!el) return;
    el.querySelectorAll('.em-product-gallery').forEach(initGallery);
    el.querySelectorAll('.em-upsell').forEach(initUpsell);
    el.querySelectorAll('[data-payments-wrap]').forEach(initPayments);
  });
})();
